import styled from 'styled-components';
export var DropdownWrapper = styled.div.withConfig({
  displayName: "IconTypestyles__DropdownWrapper",
  componentId: "keen-widget-settings__sc-18x6ty1-0"
})(["&&&{position:absolute;top:", "px;left:", "px;min-width:152px;}"], function (props) {
  return props.y;
}, function (props) {
  return props.x;
});
export var DropableContainerWrapper = styled.div.withConfig({
  displayName: "IconTypestyles__DropableContainerWrapper",
  componentId: "keen-widget-settings__sc-18x6ty1-1"
})(["&&&{min-width:152px;}"]);